const options = [
  { label: 'Albania', value: 'albania', data: 1 },
  { label: 'Austria', value: 'austria', data: 3 },
  { label: 'Belgium', value: 'belgium', data: 4 },
  { label: 'Bulgaria', value: 'bulgaria', data: 1 },
  { label: 'Croatia', value: 'croatia', data: 2 },
  { label: 'Cyprus', value: 'cyprus', data: 2 },
  { label: 'Czechia', value: 'czechia', data: 3 },
  { label: 'Denmark', value: 'denmark', data: 2 },
  { label: 'Estonia', value: 'estonia', data: 2 },
  { label: 'Finland', value: 'finland', data: 3 },
  { label: 'France', value: 'france', data: 4 },
  { label: 'Germany', value: 'germany', data: 5 },
  { label: 'Greece', value: 'greece', data: 3 },
  { label: 'Hungary', value: 'hungary', data: 2 },
  { label: 'Iceland', value: 'iceland', data: 1 },
  { label: 'Ireland', value: 'ireland', data: 3 },
  { label: 'Italy', value: 'italy', data: 3 },
  { label: 'Lithuania', value: 'lithuania', data: 2 },
  { label: 'Luxembourg', value: 'luxembourg', data: 2 },
  { label: 'Malta', value: 'malta', data: 1 },
  { label: 'Netherlands', value: 'netherlands', data: 2 },
  { label: 'North Macedonia', value: 'north-macedonia', data: 1 },
  { label: 'Norway', value: 'norway', data: 2 },
  { label: 'Poland', value: 'poland', data: 3 },
  { label: 'Portugal', value: 'portugal', data: 3 },
  { label: 'Romania', value: 'romania', data: 1 },
  { label: 'Serbia', value: 'serbia', data: 4 },
  { label: 'Slovakia', value: 'slovakia', data: 3 },
  { label: 'Slovenia', value: 'slovenia', data: 1 },
  { label: 'Spain', value: 'spain', data: 3 },
  { label: 'Sweden', value: 'sweden', data: 2 },
  { label: 'Switzerland', value: 'switzerland', data: 1 },
];

export {
  options,
}